export const routePaths = {
  homepage: {
    en: '/',
    cz: '/cz',
  },
  faq: {
    en: '/faq',
    cz: '/cz/faq',
  },
  connection: {
    en: '/connection',
    cz: '/cz/pripojeni',
  },
  privacy: {
    en: '/privacy',
    cz: '/cz/ochrana-osobnich-udaju',
  },
  locations: {
    en: '/locations',
    cz: '/cz/lokality',
  },
  statistics: {
    en: '/statistics',
    cz: '/cz/statistiky',
  },
  servicesPricing: {
    en: '/services',
    cz: '/cz/sluzby',
  },
  networks: {
    en: '/networks',
    cz: '/cz/site',
  },
  contact: {
    en: '/contact',
    cz: '/cz/kontakt',
  },
  contactSupport: {
    en: '/contact/support',
    cz: '/cz/kontakt/podpora',
  },
  contactSales: {
    en: '/contact/sales',
    cz: '/cz/kontakt/obchod',
  },
  technical: {
    en: '/technical',
    cz: '/cz/technicke-reseni',
  },
  about: {
    en: '/about',
    cz: '/cz/o-nas',
  },
};



// WEBPACK FOOTER //
// /www/client/config/routePaths.js